import React from "react";
import PropTypes from "prop-types";

import { StyledButton } from "ui/StyledComponents/StyledButton";

import { DialogActions as MuiDialogActions } from "@mui/material";

const DialogActions = ({ onCancel, onClose, disabled, ctaText="Preview Changes", cancelText="Cancel" }) => {
  
  return (
    <MuiDialogActions sx={{ px: 3, pb: 3, justifyContent: "flex-end !important" }}>
      {onCancel && 
        <StyledButton onClick={onCancel} variant="outlined">
          {cancelText}
        </StyledButton>}
      {onClose && ctaText && 
        <StyledButton
          onClick={onClose}
          variant="contained"
          color="primary"
          disabled={disabled}
        >
          {ctaText}
        </StyledButton>
      }
    </MuiDialogActions>
  );
};

DialogActions.propTypes = {
  onCancel: PropTypes.func,
  onClose: PropTypes.func,
  disabled: PropTypes.bool,
  ctaText: PropTypes.string,
  cancelText: PropTypes.string,
};

export default DialogActions;
